export default function DeleteAccount() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-14">
      <h1 className="text-4xl font-extrabold mb-2">Hesap ve Veri Silme</h1>
      <p className="text-textSecondary mb-8">
        Kelime Yarışı (<span className="font-mono">com.zyron.kelimeyarisi</span>){" "}
        hesabını ve ilişkili tüm verini kalıcı olarak silebilirsin.
      </p>

      <div className="card p-6 mb-6">
        <h2 className="font-extrabold text-lg mb-3">
          Uygulama içinden silme (önerilen)
        </h2>
        <ol className="text-textSecondary leading-relaxed space-y-2 list-decimal list-inside">
          <li>Uygulamayı aç ve giriş yap.</li>
          <li>
            <span className="font-semibold">Ayarlar</span> ekranına git.
          </li>
          <li>
            <span className="font-semibold">Hesabı Sil</span> seçeneğine dokun.
          </li>
          <li>Onayla — hesabın ve verin anında ve kalıcı olarak silinir.</li>
        </ol>
      </div>

      <div className="card p-6 mb-6">
        <h2 className="font-extrabold text-lg mb-3">
          Uygulamayı açamıyorsan
        </h2>
        <p className="text-textSecondary leading-relaxed">
          Hesabını oluştururken kullandığın e-posta adresinden{" "}
          <a
            className="text-primarySoft font-semibold"
            href="mailto:info@zyronajans.com?subject=Hesap%20Silme%20Talebi"
          >
            info@zyronajans.com
          </a>{" "}
          adresine “Hesap Silme Talebi” konulu bir e-posta gönder. Kimliğin
          doğrulandıktan sonra talebin 30 gün içinde tamamlanır.
        </p>
      </div>

      <div className="card p-6 mb-6">
        <h2 className="font-extrabold text-lg mb-3">Silinen veriler</h2>
        <p className="text-textSecondary leading-relaxed mb-2">
          Hesap silindiğinde aşağıdaki verilerin kalıcı olarak kaldırılır:
        </p>
        <ul className="text-textSecondary leading-relaxed space-y-1 list-disc list-inside">
          <li>Hesap bilgileri (e-posta, telefon, oyuncu adı)</li>
          <li>Oyun istatistikleri (galibiyet, seri, elmas ve can)</li>
          <li>Maç geçmişi</li>
          <li>Arkadaşlık bağlantıları</li>
          <li>Bildirim (FCM) token’ları</li>
        </ul>
      </div>

      <div className="card p-6">
        <h2 className="font-extrabold text-lg mb-2">Saklama süresi</h2>
        <p className="text-textSecondary leading-relaxed">
          Silme işlemi geri alınamaz. Yasal bir zorunluluk olmadığı sürece hiçbir
          kişisel verin saklanmaz; veriler talebin işlenmesiyle birlikte kalıcı
          olarak kaldırılır.
        </p>
      </div>
    </div>
  );
}
